var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import moment from 'moment-timezone';
export var ValidDateFormats;
(function (ValidDateFormats) {
    ValidDateFormats["Day"] = "D";
    ValidDateFormats["ShortDisplay"] = "DD MMM YY";
    ValidDateFormats["Display"] = "DD MMM YYYY";
    ValidDateFormats["DisplayWithHyphen"] = "DD-MMM-YYYY";
    ValidDateFormats["DisplayWithHyphenShortMonth"] = "DD-MM-YYYY";
    ValidDateFormats["Edit"] = "DD/MM/YYYY";
    ValidDateFormats["DisplaySlashSpace"] = "DD / MM / YYYY";
    ValidDateFormats["ExpiryEdit"] = "MM/YYYY";
    ValidDateFormats["Year"] = "YYYY";
    ValidDateFormats["IsoFormat"] = "YYYY-MM-DD";
    ValidDateFormats["DateTimeIso"] = "YYYY-MM-DD HH:mm:ss";
    ValidDateFormats["NodeDateTimeIso"] = "YYYY-MM-DDTHH:mm:ss";
    ValidDateFormats["NodeDateTimeTimezone"] = "YYYY-MM-DDTHH:mm:ssZ";
    ValidDateFormats["NodeDateTimezone"] = "YYYY-MM-DDT00:00:00Z";
    ValidDateFormats["PrettyPrintFullDateTime"] = "DD MMM YYYY hh:mm A";
    ValidDateFormats["PrettyPrintFullLongDateTime"] = "DD MMM YYYY hh:mm:ss A";
    ValidDateFormats["PrettyPrintTimeThenFullDate"] = "h:mm a, D MMMM YYYY";
    ValidDateFormats["PrettyPrintFullDateTimeWithBullet"] = "DD MMM YYYY \u2022 hh:mm A";
})(ValidDateFormats || (ValidDateFormats = {}));
export var ValidTimeFormats;
(function (ValidTimeFormats) {
    ValidTimeFormats["Format24HR"] = "HH:mm";
    ValidTimeFormats["IsoFormat"] = "HH:mm:ss";
    ValidTimeFormats["AMPMForm"] = "hh:mm A";
})(ValidTimeFormats || (ValidTimeFormats = {}));
export var daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export function sortDateTime(dateTime, dateTime2, asc) {
    if (asc === void 0) { asc = true; }
    if (asc)
        return dateTime.getTime() - dateTime2.getTime();
    else
        return dateTime2.getTime() - dateTime.getTime();
}
export function splitDateTimeToStrings(dateTime) {
    if (!dateTime)
        return { date: '', time: '' };
    var targetMoment = moment(dateTime, ValidDateFormats.NodeDateTimeIso, moment.tz.guess());
    var date = targetMoment.format(ValidDateFormats.Edit);
    var time = targetMoment.format(ValidTimeFormats.Format24HR);
    return { date: date, time: time };
}
export function convertStringsToMoment(date, time, timeZone) {
    if (!!timeZone)
        return moment.tz(date + " " + time, 'DD/MM/YYYY HH:mm', timeZone);
    else
        return moment.tz(date + " " + time, 'DD/MM/YYYY HH:mm', moment.tz.guess());
}
export function getNextDay(day) {
    var dayIndex = daysOfWeek.findIndex(function (it) { return day === it; });
    var nextDayIndex = dayIndex + 1;
    if (nextDayIndex > daysOfWeek.length - 1)
        nextDayIndex = 0;
    return daysOfWeek[nextDayIndex];
}
export function getPreviousDay(day) {
    var dayIndex = daysOfWeek.findIndex(function (it) { return day === it; });
    var previousDayIndex = dayIndex === 0 ? daysOfWeek.length - 1 : dayIndex - 1;
    return daysOfWeek[previousDayIndex];
}
moment.updateLocale('en', {
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        l: 'D/M/YYYY',
        LL: 'Do MMMM YYYY',
        ll: 'DD MMM YYYY',
        LLL: 'Do MMMM YYYY LT',
        lll: 'D MMM YYYY LT',
        LLLL: 'dddd, Do MMMM YYYY LT',
        llll: 'ddd, D MMM YYYY LT'
    },
    week: {
        doy: 6,
        dow: 1 // Monday is the first day of the week
    }
});
export function roundTimeIsoToEarlierMinutes(time, interval) {
    return roundTimeIsoToMinutes(time, interval, false);
}
export function roundTimeIsoToLaterMinutes(time, interval) {
    return roundTimeIsoToMinutes(time, interval, true);
}
function roundTimeIsoToMinutes(time, interval, roundUp) {
    var currentMoment = moment(time, ValidTimeFormats.Format24HR);
    if (time && currentMoment.isValid) {
        var minutes = currentMoment.minutes();
        var m = void 0;
        if (roundUp)
            m = Math.ceil(minutes / interval) * interval;
        else
            m = Math.floor(minutes / interval) * interval;
        return currentMoment.minutes(m).format(ValidTimeFormats.Format24HR);
    }
    return time;
}
export function convertEditDateToIsoDate(date) {
    if (!date)
        return '';
    var parsedDate = parseDateString(date);
    if (parsedDate)
        return moment(parsedDate).format(ValidDateFormats.IsoFormat);
    return '';
}
export function convertDateTimeToMoment(date) {
    return moment(date);
}
export function convertDateTimeToDateIso(date) {
    return moment(date).format(ValidDateFormats.IsoFormat);
}
export function convertTimeIsoToTime24Hr(timeIso) {
    var _a = __read(timeIso.split(':'), 2), hour = _a[0], minute = _a[1];
    if (hour && minute)
        return hour + ":" + minute;
    return '';
}
export function convertTime24HrToTimeIso(time) {
    if (!time)
        return time;
    return time + ':00';
}
export function convertDateIsoToDisplayDate(date) {
    if (!date)
        return '';
    var parsedDate = moment(date, ValidDateFormats.IsoFormat);
    if (parsedDate.isValid())
        return parsedDate.format(ValidDateFormats.Display);
    return '';
}
export function convertDateIsoToOther(date, targetFormat) {
    var dateAsMoment = moment(date, ValidDateFormats.IsoFormat);
    return dateAsMoment.isValid() ? dateAsMoment.format(targetFormat) : '';
}
export function parseDateString(date) {
    if (!date)
        return null;
    var parsedDate = moment(date, [ValidDateFormats.Edit, ValidDateFormats.Display, ValidDateFormats.IsoFormat]);
    if (parsedDate.isValid())
        return parsedDate.toDate();
    return null;
}
export function ageFromDateIso(birthDate, isDeceased, deathDate) {
    if (!birthDate)
        return '';
    if (isDeceased && !deathDate)
        return '';
    var startDate = moment(birthDate);
    var endDate = deathDate ? moment(deathDate) : moment();
    startDate.startOf('day');
    endDate.startOf('day');
    var diffInDays = endDate.diff(startDate, 'days');
    var diffInMonths = endDate.diff(startDate, 'months');
    var diffInYears = endDate.diff(startDate, 'years', true);
    if (diffInDays <= 21) {
        return endDate.diff(startDate, 'days') + "d";
    }
    else if (diffInMonths <= 2) {
        return endDate.diff(startDate, 'weeks') + "w";
    }
    else if (diffInMonths <= 12) {
        return endDate.diff(startDate, 'months') + "m";
    }
    else if (diffInYears <= 10) {
        var ageInYears = endDate.diff(startDate, 'y');
        var returnValue = ageInYears + "y";
        var remainingMonths = endDate.diff(moment(birthDate).add(ageInYears, 'years'), 'months');
        if (remainingMonths > 0) {
            returnValue += " " + remainingMonths + "m";
        }
        return returnValue;
    }
    return endDate.diff(startDate, 'years') + "y";
}
export function convertDateOrNullToString(date, format) {
    if (format === void 0) { format = 'DD/MM/YYYY'; }
    return !!date ? moment(date).format(format) : null;
}
export function duration(firstDate, secondDate) {
    var fromDate = firstDate;
    var toDate = secondDate;
    if (!fromDate.isValid() || !toDate.isValid())
        return '';
    fromDate.endOf('day');
    toDate.endOf('day');
    if (fromDate > toDate) {
        var tempDate = toDate;
        toDate = fromDate;
        fromDate = tempDate;
    }
    var yearsDiff = toDate.diff(fromDate, 'years');
    var yearsOutput = yearsDiff + " " + (yearsDiff > 1 ? 'years' : 'year');
    if (yearsDiff >= 3)
        return yearsDiff + " years";
    fromDate = fromDate.add(yearsDiff, 'years');
    var monthsDiff = toDate.diff(fromDate, 'months');
    var monthsOutput = monthsDiff + " " + (monthsDiff > 1 ? 'months' : 'month');
    fromDate = fromDate.add(monthsDiff, 'months');
    if (yearsDiff > 0)
        return monthsDiff > 0 ? yearsOutput + " " + monthsOutput : yearsOutput;
    var weeksDiff = toDate.diff(fromDate, 'weeks');
    var weeksOutput = weeksDiff + " " + (weeksDiff > 1 ? 'weeks' : 'week');
    fromDate = fromDate.add(weeksDiff, 'weeks');
    if (monthsDiff > 0)
        return weeksDiff > 0 ? monthsOutput + " " + weeksOutput : monthsOutput;
    var daysDiff = toDate.diff(fromDate, 'days');
    var daysOutput = daysDiff + " " + (daysDiff > 1 ? 'days' : 'day');
    if (weeksDiff > 0)
        return daysDiff > 0 ? weeksOutput + " " + daysOutput : weeksOutput;
    if (daysDiff > 0)
        return daysOutput;
    return '';
}
export var overdueByMinute = function (date) {
    var dueDate = date.endOf('minute');
    var diff = moment().endOf('minute').diff(dueDate, 'minutes');
    return diff > 0;
};
